import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/contact/personal_group_big.svg';
const PersonalGroupBigSvg = () => React.createElement(IconSvg, null);
export default PersonalGroupBigSvg;
